import { createStore } from '../createStore';

export interface KeyboardData {
  keysDown: string[];
  keysUp: string[];
}

export const keyboardDefault: KeyboardData = {
  keysDown: [],
  keysUp: [],
};

export const [KeyboardStoreProvider, useKeyboardStore] = createStore<KeyboardData>(keyboardDefault);
